import { render } from "./FoodMenu.vue?vue&type=template&id=0cc40c50"
import script from "./FoodMenu.vue?vue&type=script&lang=ts"
export * from "./FoodMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script